export const CITIES = [
    'تهران', 'کرج', 'مشهد', 'اصفهان', 'شیراز', 'تبریز', 'قم', 'اهواز', 'رشت',
    'کرمانشاه', 'ارومیه', 'یزد', 'ساری', 'همدان', 'اراک', 'بندرعباس', 'زاهدان',
    'قزوین', 'گرگان', 'سایر شهرها',
];

const TEHRAN_REGIONS = Array.from({ length: 22 }, (_, i) => `منطقه ${(i + 1).toLocaleString('fa-IR')}`);
const TEHRAN_AREAS = [
    'شرق تهران', 'غرب تهران', 'شمال تهران', 'جنوب تهران', 'مرکز تهران',
    'ونک', 'سعادت‌آباد', 'شهرک غرب', 'پاسداران', 'نارمک', 'پونک', 'تهرانپارس',
    'جردن', 'الهیه', 'ولنجک', 'یوسف‌آباد', 'ستارخان', 'امیرآباد', 'صادقیه', 'شهران',
];

export const districtSuggestions = (city) => (city === 'تهران' ? [...TEHRAN_REGIONS, ...TEHRAN_AREAS] : []);
